import { SR_API_ACTION_PARTNER_TASK_GET_LIST } from 'api/actionTypes';

export default async function getList({ state, apiClient }, { listingId, partnerId }) {
  const partnerTaskList = await apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_TASK_GET_LIST,
    state: state,
    payload: {
      listingId,
      partnerId,
    },
  });

  if (partnerId) {
    state.set(['partnerTasks', 'byPartnerId', partnerId], partnerTaskList);
  } else if (listingId) {
    state.set(['partnerTasks', 'byListingId', listingId], partnerTaskList);
  }

  return partnerTaskList;
}
